const gaExists = (): boolean => {
	if (typeof (window as any).gtag === 'undefined') {
		return false
	}
	return true
}

export const GaExists = gaExists

export const TrackPageview = (page?: string): void => {
	if (!gaExists()) {
		return
	}
	;(window as any).gtag('event', 'page_view', {
		page_path: window.location.pathname + '/' + page,
	})
}

export const TrackEvent = (
	category: string,
	action: string,
	label?: string,
	value?: number,
	nonInteraction = false,
): void => {
	if (!gaExists()) {
		return
	}
	const lab = label ? label : ''
	const val = value ? value : 0
	;(window as any).gtag('event', action, {
		event_label: lab,
		event_category: category,
		value: val,
		non_interaction: nonInteraction,
	})
}

export const EnableEnhancedEcommerce = (currency?: string, callback?: () => void): void => {
	window.onload = () => {
		if (!gaExists()) {
			return
		}
		;(window as any).gtag('set', { currency: currency ? currency : 'EUR' })
		if (typeof callback !== 'undefined') {
			callback()
		}
	}
}

export const TrackCheckoutStep = (
	step: number,
	params?: Record<string, string | number>,
	category?: string,
	action?: string,
	label?: string,
	value?: number,
	nonInteraction = false,
): void => {
	if (!gaExists()) {
		return
	}

	;(window as any).gtag('event', 'set_checkout_option', {
		...params,
		checkout_step: step,
		non_interaction: nonInteraction,
	})

	const cat = category ? category : 'ecommerce'
	const act = action ? action : 'checkout step'
	const lab = label ? label : 'step ' + step
	const val = value ? value : 0
	TrackEvent(cat, act, lab, val, nonInteraction)
}

export interface Product {
	id: string
	name: string
	price: string
	quantity: number
	category?: string
	brand?: string
	variant?: string
}

export const TrackPurchase = (id: string, revenue: string, products: Product[]): void => {
	if (!gaExists()) {
		return
	}
	;(window as any).gtag('event', 'purchase', {
		transaction_id: id,
		affiliation: 'Readpeak app',
		value: revenue,
		items: products,
	})

	TrackEvent('ecommerce', 'checkout step', 'purchase')
}

/* eslint-disable prefer-arrow/prefer-arrow-functions */
interface VimeoConfig {
	events: {
		Play: boolean
		Pause: boolean
		'Watch to End': boolean
		[key: string]: boolean
	}
	percentages: {
		every: number
		[key: string]: number
	}
}

export const InitVimeoVideoTracking = (configuration: VimeoConfig) => {
	;((document, window, config) => {
		'use strict'
		// The API won't work on LT IE9, so we bail if we detect those UAs
		if (navigator.userAgent.match(/MSIE [678]\./gi)) {
			return
		}

		if (document.readyState !== 'loading') {
			init()
		} else {
			document.addEventListener('DOMContentLoaded', init)
		}

		// Watch for new iframes popping in
		document.addEventListener('load', init, true)

		function trackEvent(state: string, title: string) {
			TrackEvent('Videos', state, title)
		}

		function init() {
			const iframes = document.querySelectorAll('iframe')
			if (!iframes) {
				return
			}
			const videos: Array<NodeListOf<HTMLIFrameElement>> = []
			for (const iframe of iframes as any) {
				if (isVimeo(iframe)) {
					videos.push(iframe)
				}
			}

			if (!videos.length) {
				return
			}

			loadApi(() => {
				videos.forEach((video) => listenTo(video))
			})
		}

		function isVimeo(el: any) {
			return el.src.indexOf('player.vimeo.com/video/') > -1
		}

		function loadApi(callback: () => void) {
			if (isUndefined_(window.Vimeo)) {
				loadScript('https://player.vimeo.com/api/player.js', callback)
			} else {
				callback()
			}
		}

		function listenTo(el: any) {
			if (el.__vimeoTracked) {
				return
			}
			el.__vimeoTracked = true

			const video = new window.Vimeo.Player(el)
			const percentages = config.percentages
			const eventNameDict: { [key: string]: string } = {
				Play: 'play',
				Pause: 'pause',
				'Watch to End': 'ended',
			}
			const cache: number[] = []

			video.getVideoTitle().then((title: string) => {
				;['Play', 'Pause', 'Watch to End'].forEach((key: string) => {
					if (config.events[key]) {
						video.on(eventNameDict[key], () => {
							trackEvent(key, title)
						})
					}
				})

				if (percentages) {
					video.on('timeupdate', (evt: any) => {
						const percentage = evt ? evt.percent * 100 : 0
						const roundedPercentage = Math.round(percentage * (1 / percentages.every)) * percentages.every
						if (percentage >= percentages.every && !cache.includes(roundedPercentage)) {
							cache.push(roundedPercentage)
							trackEvent(roundedPercentage.toString(), title)
						}
					})
				}
			})
		}

		// eslint-disable-next-line @typescript-eslint/naming-convention
		function isUndefined_(thing: any) {
			return typeof thing === 'undefined'
		}

		function loadScript(src: string, callback: () => void) {
			const f = document.getElementsByTagName('script')[0]
			const s = document.createElement('script')
			s.onload = callCallback
			s.src = src
			s.async = true
			if (f) {
				f.parentNode!.insertBefore(s, f)
			}

			function callCallback() {
				if (callback) {
					callback()
					s.onload = null
				}
			}
		}
	})(document, window as any, configuration)
	/*
	 * v1.0.2
	 * Created by the Google Analytics consultants at http://www.lunametrics.com
	 * Written by @notdanwilkerson
	 * Documentation: https://github.com/lunametrics/vimeo-google-analytics/
	 * Licensed under the MIT License
	 */
}
